import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const InputRadioButton = ({
    id = "",
    text = "",
    subText = "",
    isRevamped = false,
    radioGroupName = "radio-group",
    ...rest
}) => {

    return (
        <div styleName={`styles.inputRadioButton ${isRevamped ? "styles.radioWrapper" : ""}`}>
            <input id={id} type="radio" name={radioGroupName} {...rest} />
            <label htmlFor={id}>
                {text}
                { subText &&
                    <span>
                        {subText}
                    </span>
                }
            </label>
        </div>
    );
};

InputRadioButton.propTypes = {
    text: PropTypes.string,
    subText: PropTypes.string,
    id: PropTypes.string,
    isRevamped: PropTypes.bool,
    radioGroupName: PropTypes.string
};
export default InputRadioButton;
